module.exports = __webpack_public_path__ + "static/media/thumbnail.be7feeff.jpg";